import { render, staticRenderFns } from "./DataFastPayment.vue?vue&type=template&id=eca1ac5e&scoped=true"
import script from "./DataFastPayment.vue?vue&type=script&lang=js"
export * from "./DataFastPayment.vue?vue&type=script&lang=js"
import style0 from "./DataFastPayment.vue?vue&type=style&index=0&id=eca1ac5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca1ac5e",
  null
  
)

export default component.exports